const paymentsTypesMap = {
  bank_transfer: 'bank_transfer',
  paypal: 'paypal',
}
export default paymentsTypesMap
